import commonEn from './en/translation.json';
import commonIt from './it/translation.json';

import cookiesEn from './en/translation.cookies.json';
import cookiesIt from './it/translation.cookies.json';

import notificationsEn from './en/translation.notifications.json';
import notificationsIt from './it/translation.notifications.json';

export const commonDictionaryEn = { ...commonEn };
export const commonDictionaryIT = { ...commonIt };

export const cookiesDictionaryEn = { ...cookiesEn };
export const cookiesDictionaryIT = { ...cookiesIt };

export const dictionaries = {
  en: {
    translation: { ...commonEn, ...cookiesEn, ...notificationsEn }
  },
  it: {
    translation: { ...commonIt, ...cookiesIt, ...notificationsIt }
  }
};